import { CatalogAdminComponent } from './../catalog-admin/catalog-admin.component';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { DictionaryEntry } from '@sdbn/common';
import { DialogService } from '@sdbn/common';
import { Catalog } from '../../catalog.model';
import { ChangeCatalogDialogComponent } from '../change-catalog-dialog/change-catalog-dialog.component';
import { AppServerAPI } from '@sdbn/common';
import { importCostsPricesDialogComponent } from '../import-costsprice-dialog/import-costsprice-dialog.component';

@Component({
  selector: 'app-catalog-masterdata',
  templateUrl: './catalog-masterdata.component.html',
  styleUrls: ['./catalog-masterdata.component.scss']
})
export class CatalogMasterdataComponent implements OnInit {

  @Input() catalog: Catalog;

  @Input() catalogAdminComponent: CatalogAdminComponent;

  profileForm = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
  });

  downloadEnabled = true;

  constructor(
    private appServerAPI: AppServerAPI,
    private dialogService: DialogService
  ) {

  }

  ngOnInit(): void {
  }

  public onNameChanged(dictionary: DictionaryEntry) {
    this.catalog.name = new DictionaryEntry(dictionary);
  }

  changeCatalogTitle() {
    this.dialogService.openDefault(ChangeCatalogDialogComponent, { catalog: this.catalog })
      .afterClosed().subscribe(value => {
        this.catalogAdminComponent.readCatalogData();
      });
  }

  exportCatalogArticles() {
    this.downloadEnabled = false;

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'catalog articles export');

    // keep focus in current window
    window.focus();

    const url = `/client/erp-article/catalog/exportCatalogArticles`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, {id: this.catalog.id}).subscribe(result => {

      const file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }
      this.downloadEnabled = true;

    }, error => {
      console.error(error);
      this.downloadEnabled = true;
    });
  }

  importCostsPrices() {

    this.dialogService.openDefault(importCostsPricesDialogComponent, {})
      .afterClosed();
  }


}
